import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BlogHero from '../components/blog/BlogHero';
import BlogFeatured from '../components/blog/BlogFeatured';
import BlogGrid from '../components/blog/BlogGrid';
import BlogSidebar from '../components/blog/BlogSidebar';
import { Helmet } from 'react-helmet-async';

const BlogPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  return (
    <>
      <Helmet>
        <title>Ojasa Mirai Blog | Insights on AI, LLMs, and Developer Growth</title>
        <meta name="description" content="Explore practical articles on AI development, LLM trends, and career insights for aspiring GenAI developers from the Ojasa Mirai mentor team." />
      </Helmet>
      <Box>
        <Navbar />
        <BlogHero
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
        <BlogFeatured />
        <Box maxW="1200px" mx="auto" px={{ base: 4, md: 8 }} py={12}>
          <Box display={{ base: 'block', lg: 'flex' }} gap={8}>
            <Box flex="1">
              <BlogGrid
                searchQuery={searchQuery}
                selectedCategory={selectedCategory}
              />
            </Box>
            <Box w={{ base: '100%', lg: '300px' }} mt={{ base: 8, lg: 0 }}>
              <BlogSidebar setSelectedCategory={setSelectedCategory} />
            </Box>
          </Box>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default BlogPage;
